import getReportsStore from "../../../../stores/reports-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ReportListItem from "../../../../components/reports-list-item";
import React from "react";

const ReportsByType = withLiteObserverAndTheme(() => {
  const shouldShow = getReportsStore().isDefinedReportsByTypeData.get();
  const reportsData = getReportsStore().reportsByType.get();
  const status = getReportsStore().status.get().value;

  return shouldShow ? (
    <React.Fragment>
      {reportsData.map((report) => {
        return (
          <ReportListItem
            key={report.reportId}
            pageName={"REPORTS"}
            report={report}
            status={status}
            takenActionType={""}
            eventID={0}
            date={report.reportedOn}
            reportNumberFromPartition={0}
            reportsPartitionMaxNumber={0}
          />
        );
      })}
    </React.Fragment>
  ) : null;
});

export default ReportsByType;
